<template>
    <div>
        <notifications group="Redirect" />
    </div>
</template>

<script>
import Vue from 'vue';

const failureNotification = (message) => {
    Vue.notify({
        group: 'Redirect',
        title: '',
        text: message,
        type: 'error',
        duration: 3000,
        speed: 500
    });
};
export default {
    props: {
        message: String,
        notificationSettings: Object
    },
    created() {
        if (this.message) {
            setTimeout(() => {
                failureNotification(this.message);
            }, 1000);
        }
    },
};

</script>